
import React from "react";
import Mainlogo from "../src/icons/DUXSONUS(WHITE-BLACK) Transparent.png"
import Bandcamp from "../src/icons/bandcamp.png"
import Beatport from "../src/icons/beatport.png"
import Facebook from "../src/icons/fb.png"
import Instagram from "../src/icons/insta.png"
import SoundCloud from "../src/icons/soundcloud.png"



// import { createContext, useEffect, useState } from "react";

function App() {
  return (
    <div className="body">
  
 <div className="spa1">


  <div class="text-section">

    <p className="p1">Work in progress.</p>
    <p className="p1">Full version of the website is coming soon.</p>
    <br></br>
    <p className="p1">Accepting DEMOs</p>
    <p className="p1">Dux Sonus Demo Policy: Private SoundCloud Links, with available download to duxsonus[at]gmail.com</p>


    <img className="bcgimg" src={Mainlogo} alt="label logo" />

  </div>

       {/*<!-- Icons Section -->*/}

  <ul className="sm-icons-list">
    <li>
      <div className="icon">
        <a href="https://duxsonus.bandcamp.com/" target="_blank">
          <img className="button-img" alt="bandcamp logo icon" src={Bandcamp} />
        </a>
      </div>
    </li>

    <li>
      <div className="icon">
        <a href="https://www.beatport.com/label/dux-sonus/77065" target="_blank">
          <img className="button-img" alt="beatport logo icon" src={Beatport} />
        </a>
      </div>
    </li>
    <li>
      <div className="icon">
        <a href="https://www.instagram.com/andreydetochkin/?hl=en" target="_blank">
          <img className="button-img" alt="instagram logo icon" src={Instagram} />
        </a>
      </div>
    </li>
    <li>
      <div className="icon">
        <a href="https://www.facebook.com/p/Dux-Sonus-100063014150317/" target="_blank">
          <img className="button-img" alt="facebook logo icon" src={Facebook} />
        </a>
      </div>
    </li>

    <li>
      <div className="icon">
        <a href="https://soundcloud.com/andrey-detochkin" target="_blank">
          <img className="button-img" alt="soundcloud logo icon" src={SoundCloud} />
        </a>
      </div>
    </li>

  </ul>





  </div>
  <p1 className="footer-text">© Dux Sonus Records 2025</p1>
  <p1 className="footer-text">© Andrejs Grocs 2025</p1>

    </div>
  );
}

export default App;
